// extracted by mini-css-extract-plugin
module.exports = {"navlink":"NavLink_navlink__f8-sx"};